function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgScopeOfPractice = function SvgScopeOfPractice(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 18"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M6 12h8v-.55q0-1.125-1.1-1.787Q11.8 9 10 9t-2.9.662Q6 10.326 6 11.45zm4-4q.825 0 1.412-.588Q12 6.826 12 6q0-.824-.588-1.412A1.93 1.93 0 0 0 10 4q-.825 0-1.412.588A1.93 1.93 0 0 0 8 6q0 .824.588 1.412Q9.175 8 10 8M6 18v-2H2q-.824 0-1.412-.588A1.93 1.93 0 0 1 0 14V2Q0 1.176.588.588A1.93 1.93 0 0 1 2 0h16q.824 0 1.413.588Q20 1.175 20 2v12q0 .825-.587 1.412A1.93 1.93 0 0 1 18 16h-4v2zm-4-4h16V2H2z"
  }));
};
export default SvgScopeOfPractice;